import { formatLocalDate } from '../common/UtilsFunctions'

export default {
  getDependenciesMsg (data) {
    let dependencies = []
    dependencies.push('Existen Registros de aplicaciones de agroquimicos relacionadas con este Lote:')
    dependencies.push(' ')
    dependencies.push(...data.map(item => {
      let { applicationNumber, applicationDate } = item
      applicationDate = formatLocalDate(applicationDate)
      return `Aplicación número: ${applicationNumber}, fecha: ${applicationDate}. `
    }))
    dependencies.push(' ')
    dependencies.push(' ')
    dependencies.push('Por favor, elimine las dependencias y vuelva a intentarlo.')
    return dependencies
  }
}
